module.exports = __webpack_public_path__ + "media/application/images/youtube-703d75f4491880ac5b3d4623371ea7cd.svg";